import { defineStore } from "pinia";
import Api from "../utils/api";

export const useAppSettingsStore = defineStore("app_settings_store", {
  persist: true,
  state: () => ({
    app_settings: {}
  }),
  getters: {
    getAppSettings: (state) => (key) => {
      if (key) {
        return state.app_settings[key];
      }
      return state.app_settings;
    }
  },
  actions: {
    async fetchAppSettings() {
      try {
        const result = await Api.AppSettings.getAppSettings();
        if (result.error) {
          throw result.error;
        }
        result.data.forEach((item) => {
          this.app_settings[item.key] = item.value;
        });
      } catch (error) {
        throw { error };
      }
    }
  },
  $reset() {
    this.$state = this.$options.state(); // Reset state to its initial values
  }
});
